// Client-safe enum mirrors generated from prisma/schema/enums.prisma.
// Using literal objects avoids pulling in the Prisma runtime on bundles (e.g., Expo).
export const Sex = {
  M: 'M',
  F: 'F',
  Other: 'Other',
} as const;
export type Sex = (typeof Sex)[keyof typeof Sex];

export const WorkoutStatus = {
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
} as const;
export type WorkoutStatus = (typeof WorkoutStatus)[keyof typeof WorkoutStatus];

export const ZoneType = {
  HEART_RATE: 'HEART_RATE',
  POWER: 'POWER',
} as const;
export type ZoneType = (typeof ZoneType)[keyof typeof ZoneType];

export const ZoneCalcMethod = {
  Karvonen: 'Karvonen',
  Zoladz: 'Zoladz',
  FoxHaskell: 'FoxHaskell',
} as const;
export type ZoneCalcMethod =
  (typeof ZoneCalcMethod)[keyof typeof ZoneCalcMethod];

export const PlanGoal = {
  Marathon: 'Marathon',
  HalfMarathon: 'HalfMarathon',
  Triathlon: 'Triathlon',
  Swimming: 'Swimming',
  FiveKRun: 'FiveKRun',
  TenKRun: 'TenKRun',
  HappyRun: 'HappyRun',
} as const;
export type PlanGoal = (typeof PlanGoal)[keyof typeof PlanGoal];

export const Status = {
  ACTIVE: 'ACTIVE',
  ARCHIVED: 'ARCHIVED',
} as const;
export type Status = (typeof Status)[keyof typeof Status];

export const TimePeriod = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
  MONTHLY: 'MONTHLY',
  SEASONAL: 'SEASONAL',
} as const;
export type TimePeriod = (typeof TimePeriod)[keyof typeof TimePeriod];

export const CreatedSource = {
  PLAN_INSTANCE: 'PLAN_INSTANCE',
  USER_APP: 'USER_APP',
} as const;
export type CreatedSource = (typeof CreatedSource)[keyof typeof CreatedSource];

export const AdjustmentScope = {
  DAILY: 'DAILY',
  WEEKLY: 'WEEKLY',
} as const;
export type AdjustmentScope =
  (typeof AdjustmentScope)[keyof typeof AdjustmentScope];

export const AdjustmentSource = {
  CRON: 'CRON',
  USER: 'USER',
} as const;
export type AdjustmentSource =
  (typeof AdjustmentSource)[keyof typeof AdjustmentSource];

export const EventStatus = {
  PENDING: 'PENDING',
  PROCESSED: 'PROCESSED',
  FAILED: 'FAILED',
} as const;
export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus];

export const UnitSystem = {
  scientific: 'scientific',
  imperial: 'imperial',
} as const;
export type UnitSystem = (typeof UnitSystem)[keyof typeof UnitSystem];

export type {
  Activity,
  Workout,
  User,
  Analysis,
  TrainingSetting,
  TrainingZone,
  ForumCategory,
  ForumComment,
  ForumPost,
  ForumUser,
  GarminWorkout,
  StravaActivity,
  Sport,
  StravaLap,
  Lap,
  CoachMessage,
  Plan,
  TimelyAnalysis,
  RaceTarget,
  CoachProfile,
  CoachPolicy,
  CoachPlan,
  Prisma,
} from '@prisma/client';
